// @ts-nocheck
/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * SUREnet alerts-public API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';
import { unref } from 'vue';
import type { MaybeRef } from 'vue';
import type { AlertsFeaturesAlertPolisStandaardAlertCreateStandaardAlertStandaardAlertDto } from '../model/alertsFeaturesAlertPolisStandaardAlertCreateStandaardAlertStandaardAlertDto';
import type { AlertsFeaturesAlertPolisStandaardAlertUpdateStandaardAlertStandaardAlertDto } from '../model/alertsFeaturesAlertPolisStandaardAlertUpdateStandaardAlertStandaardAlertDto';
import type { CollectionResultOfAlertsFeaturesAlertPolisStandaardAlertGetStandaardAlertsByAdviseurStandaardAlertDto } from '../model/collectionResultOfAlertsFeaturesAlertPolisStandaardAlertGetStandaardAlertsByAdviseurStandaardAlertDto';
import type { StandaardAlertsGetByAdviseurParams } from '../model/standaardAlertsGetByAdviseurParams';
import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: StandaardAlerts.StandaardAlertBijwerken</li></ul>
 * @summary Werkt een standaardalert bij
 */
export const standaardAlertsUpdate = (
  standaardAlertId: MaybeRef<string | undefined | null>,
  alertsFeaturesAlertPolisStandaardAlertUpdateStandaardAlertStandaardAlertDto: MaybeRef<AlertsFeaturesAlertPolisStandaardAlertUpdateStandaardAlertStandaardAlertDto>,
  options?: SecondParameter<typeof customInstance>,
) => {
  standaardAlertId = unref(standaardAlertId);
  alertsFeaturesAlertPolisStandaardAlertUpdateStandaardAlertStandaardAlertDto = unref(
    alertsFeaturesAlertPolisStandaardAlertUpdateStandaardAlertStandaardAlertDto,
  );

  return customInstance<void>(
    {
      url: `/api/v1/standaardalerts/${standaardAlertId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: alertsFeaturesAlertPolisStandaardAlertUpdateStandaardAlertStandaardAlertDto,
    },
    options,
  );
};

export const getStandaardAlertsUpdateMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof standaardAlertsUpdate>>,
    TError,
    {
      standaardAlertId: string | undefined | null;
      data: AlertsFeaturesAlertPolisStandaardAlertUpdateStandaardAlertStandaardAlertDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof standaardAlertsUpdate>>,
  TError,
  {
    standaardAlertId: string | undefined | null;
    data: AlertsFeaturesAlertPolisStandaardAlertUpdateStandaardAlertStandaardAlertDto;
  },
  TContext
> => {
  const mutationKey = ['standaardAlertsUpdate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof standaardAlertsUpdate>>,
    {
      standaardAlertId: string | undefined | null;
      data: AlertsFeaturesAlertPolisStandaardAlertUpdateStandaardAlertStandaardAlertDto;
    }
  > = (props) => {
    const { standaardAlertId, data } = props ?? {};

    return standaardAlertsUpdate(standaardAlertId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StandaardAlertsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof standaardAlertsUpdate>>
>;
export type StandaardAlertsUpdateMutationBody =
  AlertsFeaturesAlertPolisStandaardAlertUpdateStandaardAlertStandaardAlertDto;
export type StandaardAlertsUpdateMutationError = ErrorType<void>;

/**
 * @summary Werkt een standaardalert bij
 */
export const useStandaardAlertsUpdate = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof standaardAlertsUpdate>>,
    TError,
    {
      standaardAlertId: string | undefined | null;
      data: AlertsFeaturesAlertPolisStandaardAlertUpdateStandaardAlertStandaardAlertDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationReturnType<
  Awaited<ReturnType<typeof standaardAlertsUpdate>>,
  TError,
  {
    standaardAlertId: string | undefined | null;
    data: AlertsFeaturesAlertPolisStandaardAlertUpdateStandaardAlertStandaardAlertDto;
  },
  TContext
> => {
  const mutationOptions = getStandaardAlertsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: StandaardAlerts.StandaardAlertBijwerken</li></ul>
 * @summary Verwijdert een standaardalert
 */
export const standaardAlertsDelete = (
  standaardAlertId: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
) => {
  standaardAlertId = unref(standaardAlertId);

  return customInstance<void>(
    { url: `/api/v1/standaardalerts/${standaardAlertId}`, method: 'DELETE' },
    options,
  );
};

export const getStandaardAlertsDeleteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof standaardAlertsDelete>>,
    TError,
    { standaardAlertId: string | undefined | null },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof standaardAlertsDelete>>,
  TError,
  { standaardAlertId: string | undefined | null },
  TContext
> => {
  const mutationKey = ['standaardAlertsDelete'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof standaardAlertsDelete>>,
    { standaardAlertId: string | undefined | null }
  > = (props) => {
    const { standaardAlertId } = props ?? {};

    return standaardAlertsDelete(standaardAlertId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StandaardAlertsDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof standaardAlertsDelete>>
>;

export type StandaardAlertsDeleteMutationError = ErrorType<void>;

/**
 * @summary Verwijdert een standaardalert
 */
export const useStandaardAlertsDelete = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof standaardAlertsDelete>>,
    TError,
    { standaardAlertId: string | undefined | null },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationReturnType<
  Awaited<ReturnType<typeof standaardAlertsDelete>>,
  TError,
  { standaardAlertId: string | undefined | null },
  TContext
> => {
  const mutationOptions = getStandaardAlertsDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: StandaardAlerts.StandaardAlertInzien</li></ul>
 * @summary Haalt standaardalerts op die horen bij de opgegeven adviseur.
 */
export const standaardAlertsGetByAdviseur = (
  params?: MaybeRef<StandaardAlertsGetByAdviseurParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<CollectionResultOfAlertsFeaturesAlertPolisStandaardAlertGetStandaardAlertsByAdviseurStandaardAlertDto>(
    { url: `/api/v1/standaardalerts/adviseur`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getStandaardAlertsGetByAdviseurQueryKey = (
  params?: MaybeRef<StandaardAlertsGetByAdviseurParams>,
) => ['api', 'v1', 'standaardalerts', 'adviseur', ...(params ? [params] : [])] as const;

export const getStandaardAlertsGetByAdviseurQueryOptions = <
  TData = Awaited<ReturnType<typeof standaardAlertsGetByAdviseur>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<StandaardAlertsGetByAdviseurParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof standaardAlertsGetByAdviseur>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getStandaardAlertsGetByAdviseurQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof standaardAlertsGetByAdviseur>>> = ({
    signal,
  }) => standaardAlertsGetByAdviseur(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof standaardAlertsGetByAdviseur>>,
    TError,
    TData
  >;
};

export type StandaardAlertsGetByAdviseurQueryResult = NonNullable<
  Awaited<ReturnType<typeof standaardAlertsGetByAdviseur>>
>;
export type StandaardAlertsGetByAdviseurQueryError = ErrorType<void>;

/**
 * @summary Haalt standaardalerts op die horen bij de opgegeven adviseur.
 */

export function useStandaardAlertsGetByAdviseur<
  TData = Awaited<ReturnType<typeof standaardAlertsGetByAdviseur>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<StandaardAlertsGetByAdviseurParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof standaardAlertsGetByAdviseur>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getStandaardAlertsGetByAdviseurQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: StandaardAlerts.StandaardAlertAanmaken</li></ul>
 * @summary Maakt een nieuwe standaardalert aan.
 */
export const standaardAlertsCreate = (
  alertsFeaturesAlertPolisStandaardAlertCreateStandaardAlertStandaardAlertDto: MaybeRef<AlertsFeaturesAlertPolisStandaardAlertCreateStandaardAlertStandaardAlertDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  alertsFeaturesAlertPolisStandaardAlertCreateStandaardAlertStandaardAlertDto = unref(
    alertsFeaturesAlertPolisStandaardAlertCreateStandaardAlertStandaardAlertDto,
  );

  return customInstance<void>(
    {
      url: `/api/v1/standaardalerts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: alertsFeaturesAlertPolisStandaardAlertCreateStandaardAlertStandaardAlertDto,
      signal,
    },
    options,
  );
};

export const getStandaardAlertsCreateMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof standaardAlertsCreate>>,
    TError,
    { data: AlertsFeaturesAlertPolisStandaardAlertCreateStandaardAlertStandaardAlertDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof standaardAlertsCreate>>,
  TError,
  { data: AlertsFeaturesAlertPolisStandaardAlertCreateStandaardAlertStandaardAlertDto },
  TContext
> => {
  const mutationKey = ['standaardAlertsCreate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof standaardAlertsCreate>>,
    { data: AlertsFeaturesAlertPolisStandaardAlertCreateStandaardAlertStandaardAlertDto }
  > = (props) => {
    const { data } = props ?? {};

    return standaardAlertsCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StandaardAlertsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof standaardAlertsCreate>>
>;
export type StandaardAlertsCreateMutationBody =
  AlertsFeaturesAlertPolisStandaardAlertCreateStandaardAlertStandaardAlertDto;
export type StandaardAlertsCreateMutationError = ErrorType<void>;

/**
 * @summary Maakt een nieuwe standaardalert aan.
 */
export const useStandaardAlertsCreate = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof standaardAlertsCreate>>,
    TError,
    { data: AlertsFeaturesAlertPolisStandaardAlertCreateStandaardAlertStandaardAlertDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationReturnType<
  Awaited<ReturnType<typeof standaardAlertsCreate>>,
  TError,
  { data: AlertsFeaturesAlertPolisStandaardAlertCreateStandaardAlertStandaardAlertDto },
  TContext
> => {
  const mutationOptions = getStandaardAlertsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
